/**
 * Single service script
 *
 * @author HammersportMarketing
 */
import "../../sass/single-service.scss";

function checkActiveServiceGroup() {
  var service_group = $("select.service-category")
    .children("option:selected")
    .val();
  $("section.service-group").each(function () {
    if (service_group === "featured" && $(this).hasClass("featured-service")) {
      $(this).removeClass("d-none");
      $(this).addClass("sweep");
    }else if ($(this).is(`#group-${service_group}`)) {
      $(this).removeClass("d-none");
      $(this).addClass("sweep");
    } else {
      $(this).addClass("d-none");
      $(this).removeClass("sweep");
    }
  });
}

$(function () {
  checkActiveServiceGroup();
});

$("select.service-category").on("change", function () {
  checkActiveServiceGroup();
});
